<template>
    <div>
        <div v-if="modalIsOpened" class="fixed inset-0 w-full bg-black/30 z-50">
            <div class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8">
                <div class="overflow-hidden m-auto">
                    <!-- actual modal -->
                    <div class="w-[90vw] sm:w-[90vw] md:w-[580px] md:max-w-[1000px] md:max-h-[800px] mx-auto box-effect rounded-[10px] bg-white overflow-hidden"
                        >
                        <!-- v-click-outside="closeModal" -->
                        <div id="title" class="bg-primary px-5 pr-2.5 py-3 flex justify-between items-center">
                            <span class="text-white text-[14px]">เปลี่ยนรหัสใหม่</span>
                            <CloseIcon @click="closeModal"
                                class="w-6 h-6 text-primary bg-white inline-block rounded-full cursor-pointer" />
                        </div>
                        <form @submit.prevent="handleFormSubmit" class="p-5 pt-3 grid gap-4">
                            <Input class="w-full" inputType="password" label="รหัสผ่านเก่า" placeholder="รหัสผ่านเก่า"
                                v-model="formData.old_password" :error="errors?.old_password" />
                            <Input class="w-full" inputType="password" label="รหัสผ่านใหม่" placeholder="รหัสผ่านใหม่"
                                v-model="formData.password" :error="errors?.password" @update:modelValue="onType" />
                            <ul class="custUl w-full grid gap-2.5 lg:my-4 text-primary-dark text-[14px]">
                                <li class="flex items-center gap-2.5">
                                    <CheckTickIcon bg="#7C7379" class="text-white w-[16px] h-[16px] shrink-0" />
                                    <span>ไม่สามารถตั้งรหัสผ่านเป็น ภาษาไทย</span>
                                </li>
                                <li class="flex items-center gap-2.5">
                                    <CheckTickIcon bg="#7C7379" class="text-white w-[16px] h-[16px] shrink-0" />
                                    <span>ต้องมีการกรอกตัวอักษร อังกฤษ ทั้งตัวพิมพ์ใหญ่ และ พิมพ์เล็ก</span>
                                </li>
                                <li class="flex items-center gap-2.5">
                                    <CheckTickIcon bg="#7C7379" class="text-white w-[16px] h-[16px] shrink-0" />
                                    <span>ต้องมีการกรอกตัวเลข ผสมอยู่ในรหัสผ่าน อย่างน้อย 1 ตัว</span>
                                </li>
                                <li class="flex items-center gap-2.5">
                                    <CheckTickIcon bg="#7C7379" class="text-white w-[16px] h-[16px] shrink-0" />
                                    <div>
                                        <span>ต้องมีการกรอกอักขระพิเศษผสมอยู่ในรหัสผ่าน อย่างน้อย 1 ตัว !@#$%^&*()_+|~-=\{}[]:;<>?./</span>
                                    </div>
                                </li>
                                <li class="flex items-center gap-2.5">
                                    <CheckTickIcon bg="#7C7379" class="text-white w-[16px] h-[16px] shrink-0" />
                                    <span>ต้องตั้งรหัสผ่านความยาวอย่างน้อย 8 ตัวอักษรขึ้นไป</span>
                                </li>
                                <li class="flex items-center gap-2.5">
                                    <CheckTickIcon bg="#7C7379" class="text-white w-[16px] h-[16px] shrink-0"
                                        id="passwordMatchRef" />
                                    <span>รหัสผ่านต้องตรงกับการยืนยันรหัสผ่าน</span>
                                </li>
                            </ul>
                            <Input class="w-full" inputType="password" label="ยืนยันรหัสผ่านใหม่"
                                placeholder="ยืนยันรหัสผ่านใหม่" v-model="formData.password_confirmation"
                                :error="errors?.password_confirmation" />
                            <button v-if="requirementsMatched" type="submit"
                                class="ml-auto btn justify-center w-1/3 min-h-[50px] text-sm">บันทึก</button>
                            <div v-else
                                class="rounded-[6px] text-sm ml-auto w-1/3 py-3.5 text-center !bg-secondary-light text-grey-light cursor-not-allowed">
                                บันทึก
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <StatusModal ref="StatusModalRef" class="" />
    </div>
</template>

<script setup>
import { ref, watch, computed, onMounted } from 'vue';
import { useAuthStore } from '../../pinia/authStore';
import StatusModal from './StatusModal.vue';

const modalIsOpened = ref(false);
const formData = ref({
    old_password: '',
    password: '',
    password_confirmation: '',
    passwordsMatched: false,
})
const errors = ref({})
const StatusModalRef = ref('')
const requirements = [
    { regex: /^[\x20-\x7E]*$/, index: 0 },
    { regex: /(?=.*[A-Z])(?=.*[a-z])/, index: 1 },
    { regex: /[0-9]/, index: 2 },
    { regex: /[!@#$%^&*()_+\-=\[\]{};:\\|,.<>\/?~]/, index: 3 },
    { regex: /.{8,}/, index: 4 },
]
const requirementsMatched = ref(false)

// const formFilled = computed(() => {
//     formData.value.map(data => console.log(data))
// })

const openModal = () => {
    modalIsOpened.value = true
    document.body.style.overflow = 'hidden';
}

const closeModal = () => {
    formData.value = {
        old_password: '',
        password: '',
        password_confirmation: '',
        passwordsMatched: false,
    }
    modalIsOpened.value = false
    document.body.style.overflow = 'auto';
}

const onType = (value) => {
    const requirementLists = document.querySelectorAll('.custUl li');
    if (value != '') {
        requirements.forEach((item) => {
            const isValid = item.regex.test(value);
            const requirementItem = requirementLists[item.index];
            if (isValid) {
                requirementItem.firstChild.firstChild.classList.add('fill-primary')
            } else {
                requirementItem.firstChild.firstChild.classList.remove('fill-primary')
            }
        })
    } else {
        requirementLists.forEach(item => {
            item.firstChild.firstChild.classList.remove('fill-primary')
        })
    }
}

const handleFormSubmit = async () => {
    errors.value = {}
    try {
        const response = await useAuthStore().updatePassword(formData.value)
        formData.value = {}
        modalIsOpened.value = false;
        StatusModalRef.value.openModal('success', { subHeader: response.message }, '', 'topRight')
    } catch (error) {
        errors.value = error
    }
}

onMounted(() => {
    // console.log(formData.value)
})

// watchers
watch(() => [formData.value.password, formData.value.password_confirmation], () => {
    formData.value.passwordsMatched = formData.value.password === formData.value.password_confirmation;
    const passConfirmCheck = document.querySelector('#passwordMatchRef');
    if (formData.value.passwordsMatched && formData.value.password_confirmation != '') {
        requirementsMatched.value = requirements.every(req => req.regex.test(formData.value.password));
        passConfirmCheck.firstChild.classList.add('fill-primary')
    } else {
        passConfirmCheck.firstChild.classList.remove('fill-primary')
    }
},);

defineExpose({ openModal });
</script>

<style scoped></style>